import styled from 'styled-components';

export const MainLinksWrapper = styled.div<{
  activeLinkId: string | undefined;
}>`
  grid-row: 2;
  grid-column: 1 / span 2;

  padding: 0 1rem;
  background: white;

  a {
    display: flex;
  }

  div {
    max-width: 1240px;
    flex: 1;
    margin: 0 auto;
    display: flex;
    gap: 1rem;

    @media (min-width: 1025px) {
      display: grid;
      grid-template-columns: 116px 1fr;
      gap: 0rem;
    }
    align-items: center;

    nav {
      flex: 1;

      ul {
        flex: 1;

        gap: 2rem;
        font-size: 1.25rem;
        line-height: 1.75rem;

        li {
          padding: 1.375rem 0;
          
          a {
            border-bottom: 2px white solid;
          }

          a[id='${({ activeLinkId }) => activeLinkId}'] {
            border-bottom: 2px #e60000 solid;
            font-weight: 700;
            width: fit-content;
          }
        }
      }

      .main-nav-items {
        display: none;
        @media (min-width: 1025px) {
          display: flex;
          justify-content: flex-start;
        }
      }

      .mobile-nav-items {
        display: flex;
        justify-content: space-between;
        @media (min-width: 1025px) {
          display: none;
        }
      }
    }
  }
`;

export const BrandLogoWrapper = styled.a`
  svg {
    width: 24px;
    height: 24px;

    @media (min-width: 768px) {
      width: 36px;
      height: 36px;
    }
  }
`;